import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import TextField from '../shared/TextField';
import { setData } from '../../features/mainSlice';
import { color } from '../../app/theme';

const styles = () => ({
  name: {
    width: 512,
    marginBottom: '36px',
    '& > .input-title': {
      fontSize: '15px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      color: color.$3,
      marginBottom: '12px',
    },
  },
});

const Name = props => {
  const { classes } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { name } = useSelector(state => state.ma?.data);
  const { isActive, isSettingError } = useSelector(store => store.ma);

  const setName = event => {
    const { value } = event.target;
    dispatch(
      setData({
        name: value,
      }),
    );
  };

  return (
    <div className={classes.name}>
      <div className="input-title">{t('setting.name')}</div>
      <TextField
        type="text"
        isValid
        placeholder={t('setting.name-placeholder')}
        value={name}
        onChange={setName}
        disabled={isActive}
        error={isSettingError && !name}
      />
    </div>
  );
};

export default withStyles(styles)(Name);
